function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-41.3583 0 0 41.3583 499.9998 499.9999)",
    id: 140978
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-11.9904, -12.0011)",
    d: "M 16.3153 16.6681 C 15.9247 17.0587 15.9247 17.6918 16.3153 18.0824 C 16.7058 18.4729 17.339 18.4729 17.7295 18.0824 L 22.3951 13.4168 C 23.1761 12.6357 23.1761 11.3694 22.3951 10.5883 L 17.7266 5.9199 C 17.3361 5.52938 16.703 5.52938 16.3124 5.91991 C 15.9219 6.31043 15.9219 6.9436 16.3124 7.33412 L 19.9785 11.0002 L 2 11.0002 C 1.44772 11.0002 1 11.4479 1 12.0002 C 1 12.5524 1.44772 13.0002 2 13.0002 L 19.9832 13.0002 L 16.3153 16.6681 Z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.18db5e2f.svg";
export { ForwardRef as ReactComponent };